export function PositionCounter({
  position,
  calcEtaSeconds,
}: {
  position: number;
  calcEtaSeconds: (position: number) => number;
}) {
  const estimateSeconds = calcEtaSeconds(position);

  let hours = 0;
  let minutes = Math.floor(estimateSeconds / 60);

  if (minutes > 99) {
    hours = Math.floor(minutes / 60);
    minutes = minutes & 60;
  }

  const seconds = estimateSeconds % 60;

  return (
    <div>
      <h3 className="font-bold">
        There {position === 1 ? "is" : "are"} {position} {position === 1 ? " person" : " people"}{" "}
        ahead of you.
      </h3>
      <div className="text-xs">
        {position === 0 ? (
          "You're up next! 🎉"
        ) : (
          <>
            Estimate Wait Time:{" "}
            <time className="countdown">
              {hours > 0 && (
                <>
                  {/* @ts-ignore this works, just not typed correctly */}
                  <span style={{ "--value": hours }} />
                  h&nbsp;
                </>
              )}
              {minutes > 0 && (
                <>
                  {/* @ts-ignore this works, just not typed correctly */}
                  <span style={{ "--value": minutes }} />
                  m&nbsp;
                </>
              )}
              {seconds >= 0 && (
                <>
                  {/* @ts-ignore this works, just not typed correctly */}
                  <span style={{ "--value": seconds }} />
                  s&nbsp;
                </>
              )}
            </time>
          </>
        )}
      </div>
    </div>
  );
}
